import React from 'react';
import './page.css';

/**
 * One heading style for every workflow stage: same element (h2), size, weight and colour.
 * Deliberately antd-free so the heavily mocked stage components need no extra antd surface.
 */
const StageHeader = ({ title, status, actions }) => (
  <div className="pl-stage-header" data-testid="stage-header">
    <div className="pl-stage-header__lead">
      <h2 className="pl-stage-title">{title}</h2>
      {status ? <span data-testid="stage-header-status">{status}</span> : null}
    </div>
    {actions ? <div className="pl-stage-header__actions" data-testid="stage-header-actions">{actions}</div> : null}
  </div>
);

export default StageHeader;
